import { GET_REPORT, SET_REPORT } from "./types";

import firebase from "firebase/app";

export const getReport = (
    subjectName = null,
    uid = null,
    timestamp = null,
    reportType
) => {
    return dispatch => {
        dispatch({
            type: GET_REPORT.REQUEST
        });
        if (subjectName === null || uid === null || timestamp === null) {
            dispatch({ type: GET_REPORT.FAIL });
        }
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: GET_REPORT.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref(
                            `/subjects/${subjectName}/${uid}/reports/${reportType}/${timestamp}`
                        )
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: GET_REPORT.FAIL
            });
        }
    };
};

export const getJobPackReports = (
    uid,
    subjectName,
    status,
    year,
    month,
    timestamp,
    reportType
) => {
    return dispatch => {
        dispatch({
            type: GET_REPORT.REQUEST
        });
        if (subjectName === null || uid === null || timestamp === null) {
            dispatch({ type: GET_REPORT.FAIL });
        }
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: GET_REPORT.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref(
                            `/subjects/${subjectName}/${status}/${year}/${month}/${uid}/reports/${reportType}/${timestamp}`
                        )
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: GET_REPORT.FAIL
            });
        }
    };
};

export const setReport = (report = false, location = false) => {
    return dispatch => {
        if (report && location) {
            let locationParts = location.split("/");
            let subjectName = locationParts[2];
            if (subjectName === "jobpacks") {
                let status = locationParts[3];
                let year = locationParts[4];
                let month = locationParts[5];
                let uid = locationParts[6];
                let type = locationParts[7].replace(/-/g, "_");
                let timestamp = locationParts[8]
                    .replace(/_/g, " ")
                    .replace(/\./g, ":");
                report.job_lots_summary = null;
                try {
                    firebase.auth().onAuthStateChanged(user => {
                        if (user) {
                            firebase
                                .database()
                                .ref(
                                    `subjects/${subjectName}/${status}/${year}/${month}/${uid}/reports/${type}/${timestamp}`
                                )
                                .update(report, snapshot => {
                                    dispatch({ type: SET_REPORT.SUCCESS });
                                });
                        } else {
                            dispatch({ type: SET_REPORT.FAIL });
                        }
                    });
                } catch {
                    dispatch({ type: SET_REPORT.FAIL });
                }
            } else {
                let uid = locationParts[3];
                let type = locationParts[4].replace(/-/g, "_");
                let timestamp = locationParts[5]
                    .replace(/_/g, " ")
                    .replace(/\./g, ":");
                report.job_lots_summary = null;
                try {
                    firebase.auth().onAuthStateChanged(user => {
                        if (user) {
                            firebase
                                .database()
                                .ref(
                                    `subjects/${subjectName}/${uid}/reports/${type}/${timestamp}`
                                )
                                .update(report, snapshot => {
                                    dispatch({ type: SET_REPORT.SUCCESS });
                                });
                        } else {
                            dispatch({ type: SET_REPORT.FAIL });
                        }
                    });
                } catch {
                    dispatch({ type: SET_REPORT.FAIL });
                }
            }
        }
    };
};
